import { Amplify } from 'aws-amplify';
import baseConfig from './aws_config.json';

const awsConfig = {
  ...baseConfig,
  Auth: {
    ...baseConfig.Auth,
    Cognito: {
      ...baseConfig.Auth.Cognito,
      userPoolId: process.env.REACT_APP_USERPOOL,
      userPoolClientId: process.env.REACT_APP_API_WEBCLIENTID,
      loginWith: {
        oauth: {
          ...baseConfig.Auth.Cognito.loginWith.oauth,
          domain: `${process.env.REACT_APP_USERPOOL}.auth.us-east-1.amazoncognito.com`
        }
      }
    },
  },
};

Amplify.configure(awsConfig as any);
